var render = function render(){
  var _vm$newsItem, _vm$newsItem$article, _vm$newsItem2, _vm$newsItem2$article;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12 col-md-6 col-lg-4 col-xl-4 mb-1 mb-md-2 mb-lg-2 mb-xl-2"
  }, [_c('div', {
    staticClass: "blog-item"
  }, [_c('div', {
    staticClass: "blog-post-image-container"
  }, [_c('router-link', {
    staticClass: "blog-post-image",
    attrs: {
      "to": {
        name: 'newsdetail',
        query: {
          id: _vm.newsItem.id,
          newsPage: _vm.newsPage,
          query: _vm.query,
          isRecentNews: _vm.isRecentNews
        }
      }
    }
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.newsItem.article.largeImageURL ? _vm.newsItem.article.largeImageURL : _vm.newsDefaultImage,
      "alt": _vm.newsItem.photoDescription
    },
    on: {
      "error": function ($event) {
        return _vm.setDefaultImage($event);
      }
    }
  })])], 1), _c('div', {
    staticClass: "blog-post-title-container d-flex flex-column"
  }, [_c('div', {
    staticClass: "blog-post-title p-lg-3 p-xl-3"
  }, [_c('div', {
    staticClass: "blog-title-text d-flex flex-column justify-content-center"
  }, [_c('div', {
    staticClass: "limit-lines-2"
  }, [_vm._v(" " + _vm._s(_vm.newsItem.article.title) + " ")])])]), _c('div', {
    staticClass: "blog-post-date blog-text p-lg-3 p-xl-3"
  }, [_vm._v(" " + _vm._s((_vm$newsItem = _vm.newsItem) !== null && _vm$newsItem !== void 0 && (_vm$newsItem$article = _vm$newsItem.article) !== null && _vm$newsItem$article !== void 0 && _vm$newsItem$article.date ? _vm.getFormattedDate((_vm$newsItem2 = _vm.newsItem) === null || _vm$newsItem2 === void 0 ? void 0 : (_vm$newsItem2$article = _vm$newsItem2.article) === null || _vm$newsItem2$article === void 0 ? void 0 : _vm$newsItem2$article.date) : "") + " ")])]), _c('div', {
    staticClass: "blog-post-title-description d-flex flex-column justify-content-start mt-lg-3 mt-lx-3 px-lg-3 px-xl-3"
  }, [_c('div', {
    staticClass: "blog-text limit-lines-3"
  }, [_vm._v(" " + _vm._s(_vm.newsItem.article.headLine) + " ")])]), _c('div', {
    staticClass: "blog-post-read-details-action d-flex justify-content-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'newsdetail',
        query: {
          id: _vm.newsItem.id,
          newsPage: _vm.newsPage,
          query: _vm.query,
          isRecentNews: _vm.isRecentNews
        }
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4',
      "width": "140"
    }
  }, [_vm._v(" Read ")])], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }